module.exports = __webpack_public_path__ + "img/cpany5.3a368950.png";